import { defineAsyncComponent } from 'vue'
export default {
  "auth-layout": defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/auth-layout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/default.vue").then(m => m.default || m)),
  "onboarding-layout": defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/onboarding-layout.vue").then(m => m.default || m)),
  "single-window-layout": defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/single-window-layout.vue").then(m => m.default || m))
}